export var TOGGLE_MAP = 'TOGGLE_MAP';
export var MAP_DATE = 'MAP_DATE';
export var toggleMap = function toggleMap(toggled) {
  return {
    type: TOGGLE_MAP,
    toggled: toggled
  };
};
export var mapDate = function mapDate() {
  return {
    type: MAP_DATE
  };
};